import { Button as AntButton } from "antd";
import styled from "styled-components";

const Button = styled(AntButton)`
  background-color: #fdd440;
  color: #1070b6;
  :hover {
    background-color: #fce281;
    color: #1070b6;
  }
  :active,
  :focus {
    background-color: #fdd440;
    color: #1070b6;
  }
  border-width: 0;
  font-weight: bold;
  font-size: 16px;
  height: 36px;
  transform: scaleY(0.95);
  min-width: 130px;
  padding: 0px 20px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;

export const SectionButton = styled(Button)`
  background-color: #fdd440;
  padding: 0px 8px;
  color: #1070b6;
  border-width: 0;
  font-weight: bold;
  font-size: 16px;
  height: 36px;
  transform: scaleY(0.98);
  width: 100%;

  &:focus {
    background-color: #fdd440;
    color: #1070b6;
  }
`;

export const DummyButton = styled.div``;

export default Button;
